import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SegmentController, Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './css/App.css';
import PastWeatherContainer from './PastWeatherContainer';
import WeatherForecastContainer from './WeatherForecastContainer';
import { getCurrentUserDetails } from '../actions/currentUserActions';
import { getFieldDetails, receiveCountryFeatures, receiveFieldFeatures } from '../actions/fieldActions';
import { FieldType, UserDetailsType } from '../types';
import { HISTORIC_WEATHER } from '../constants/features';
import { trackEvent } from '../actions/analyticsActions';
import { getQueryParamValue } from '../utils/queryParam';

const PAST_WEATHER_ID = 'pastWeather';
const WEATHER_FORECAST_ID = 'weatherForecast';

const weatherIds = {
  [WEATHER_FORECAST_ID]: 'weather_forecast',
  [PAST_WEATHER_ID]: 'past_weather',
};

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab:
        getQueryParamValue('weatherType') === 'past'
          ? PAST_WEATHER_ID
          : WEATHER_FORECAST_ID,
    }
  }

  UNSAFE_componentWillMount() {
    const {
      getCurrentUserDetails: getCurrentUserDetailsProp,
      getFieldDetails: getFieldDetailsProp,
      receiveCountryFeatures: receiveCountryFeaturesProp,
      receiveFieldFeatures: receiveFieldFeaturesProp,
      fieldId,
      userCountryFeatures,
      fieldFeatures
    } = this.props;

    getCurrentUserDetailsProp();
    getFieldDetailsProp(fieldId);
    receiveCountryFeaturesProp(userCountryFeatures);
    receiveFieldFeaturesProp(fieldFeatures);
  }

  handleClickTab = (id) => {
    const { trackEvent: trackEventProp } = this.props;

    this.setState({ selectedTab: id });

    trackEventProp('weather_tab', 'selected', {
      weather_tab_name: weatherIds[id],
    });
  };

  hasHistoricWeather = (features) => features.includes(HISTORIC_WEATHER);

  render() {
    const {
      field,
      currentUser,
      fieldFeatures,
      userCountryFeatures,
      isMicrosoftWxFeatureAvailable,
    } = this.props;
    const { selectedTab } = this.state;
    const isHistoricalWeatherAvailableInCountry = this.hasHistoricWeather(userCountryFeatures);
    const isHistoricalWeatherEnabled = this.hasHistoricWeather(fieldFeatures);

    const tabConfig = [
      {
        id: PAST_WEATHER_ID,
        value: (
          <span className={styles.pastWeatherSegmentTab}>
            {getMessage('controls.pastWeatherBtn')}
          </span>
        )
      },
      {
        id: WEATHER_FORECAST_ID,
        value: (
          <span className={styles.forecastWeatherTab}>
            <Icon className={styles.segmentTabIcon} glyph={Icon.set.SUN} />
            {getMessage('controls.forecastBtn')}
          </span>
        )
      },
    ]

    return (
      <div className={styles.app}>
        {field.uuid && currentUser.countryCode ? (
          <>
            {isHistoricalWeatherAvailableInCountry && isHistoricalWeatherEnabled && (
              <div className={styles.optionsContainer}>
                <SegmentController
                  className={styles.segmentController}
                  handleClick={tab => this.handleClickTab(tab.id)}
                  selected={selectedTab}
                  tabs={tabConfig}
                  testId="weather-segment-controller"
                />
              </div>
            )}
            {selectedTab === PAST_WEATHER_ID && (<PastWeatherContainer />)}
            {selectedTab === WEATHER_FORECAST_ID && (
              <WeatherForecastContainer
                isMicrosoftWxFeatureAvailable={isMicrosoftWxFeatureAvailable}
              />
            )}
          </>
        ) : (
          <div>{getMessage('loading')}</div>
        )}
      </div>
    );
  }
}

App.propTypes = {
  currentUser: UserDetailsType,
  field: FieldType,
  fieldId: string.isRequired,
  getCurrentUserDetails: func.isRequired,
  getFieldDetails: func.isRequired,
  trackEvent: func.isRequired,
  isMicrosoftWxFeatureAvailable: bool,
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
    field: state.field,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getFieldDetails,
      getCurrentUserDetails,
      receiveCountryFeatures,
      receiveFieldFeatures,
      trackEvent,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
